module.exports = __webpack_public_path__ + "static/media/open-menu.48b4d324.svg";